import {useState } from "react";
import { useForm } from "react-hook-form";
import {
  useFetchNotificationListQuery,
  useFetchTaskActivityQuery,
  useFetchTaskDetailViewQuery,
} from "../../../slice/logdetailSlice";
import  { CommonShowDocument,} from "../../common/AddDocumentComponent";

const TaskDocument = ({ taskid }) => {
  // const [projects, setProjects] = useState();
  const [showProject, setShowProject] = useState(false);
  // const [document, SetDocument] = useState([]);
  const handleShowProject = () => setShowProject(true); // Open filter
  const { reset } = useForm();
  const { refetch: task_view } = useFetchTaskDetailViewQuery(taskid);
  // const { data: activity, refetch: task_activity_status } =
    useFetchTaskActivityQuery(taskid);
  // const { data: notification_list, refetch: notification_refetch } =
    useFetchNotificationListQuery();

  return (
    <>
      <CommonShowDocument
        refetchList={task_view}
        showPath="task/document"
        downloadPath="task/document/download"
        deletePath="task/document"
        type="task"
      />
    </>
  );
};

export default TaskDocument;
